import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {getJSON} from 'jquery';
import {ComputedOptions} from "~knockout/index";
import {getSecondaryScreenVisibilityOptions} from "../../ScreenVisibility";
import {Screen} from "../../Screen";
import {hideSecondaryScreens, showPrimaryScreen, showSecondaryScreen} from "../../ScreenManager";
import {getGameManager} from "../../../game/GameManager";
import {ILeaderboardEntry} from 'power-patrol';
import {Observable} from '~knockout/index';
import {globalConfig} from '../../../config/Config';

var template = require('./LeaderboardScreen.html');

class LeaderboardScreenComponent extends Screen
{
    initials: Observable<string>;
    submittingScore: boolean;

    /**
     * create knockout bindings
     */
    createBindings()
    {
        //  create super-class bindings

        super.createBindings();

        //  create leaderboard data binding

        this.initials = ko.observable('');
        this.initials.subscribe((initials: string) => this.checkInitials(initials))
    }


    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getSecondaryScreenVisibilityOptions('gameplay', 'leaderboard');
    }


    /**
     * limit text entry to three characters
     */
    checkInitials = (initials: string) =>
    {
        log.debug('checking input')

        if (initials.length > 3)
        {
            setTimeout(() =>
            {
                this.initials(initials.substring(0, 3));
            }, 1);
        }
    };


    /**
     * show the main menu
     */
    showMainMenu = () =>
    {
        showPrimaryScreen('main-menu');
    };


    /**
     * show the leaderboard
     */
    showLeaderboard = () =>
    {
        showPrimaryScreen('leaderboard');
    };


    /**
     * restart the game
     */
    playAgain = () =>
    {
        showPrimaryScreen('gameplay');

        getGameManager().playGame();
    };


    /**
     * submit the user's score to the db
     */
    submitScore = () =>
    {
        var name: string,
            level: number,
            score: number;

        if (this.submittingScore === true) return;

        this.submittingScore = true;

        //  create a high-score object to submit

        name = this.initials();
        level = getGameManager().currentLevel();
        score = getGameManager().score();

        //  post the score to the leaderboard

        getJSON(globalConfig.leaderboardUrl + '/api/save-score/' + name + '/' + level + '/' + score, (response: any) =>
        {
            setTimeout(() =>
            {
                this.submittingScore = false;
            }, 2000);

            showPrimaryScreen('leaderboard', response.position);
        });
    }
}


/**
 * register this component with knockout
 * @param vizID
 */
export function registerGameplayLeaderboardScreenComponent()
{
    ko.components.register('pp-gameplay-leaderboard-overlay',
        {
            viewModel: () => { return new LeaderboardScreenComponent() },
            template: template
        });
}



// WEBPACK FOOTER //
// ./src/ts/screens/gameplay/leaderboard/LeaderboardScreen.ts